<template>
    <div style="position: relative">
        <title-and-edit currentViewTitle="Mine salonger" @toggleEdit="toggleEdit" :edit="edit" :hideEditButton="!salons.length" :layout="layout"/>
        <div class="profile__container--content__mysalons primary-font pt-5">
            <div v-if="salons.length">
                <div v-for="salon in visiblePages" :key="salon.title">
                    <salon :salon="salon" :edit="edit" :layout="layout" @delete-salon="updateSalon" @setSalon="x => removedSalon = x"></salon>
                </div>
                <v-pagination
                    v-if="allSalons.length > 10"
                    class="profile__container--content__mysalons--pagination my-5"
                    circle
                    v-model="page"
                    :length="pages"
                    :total-visible="10"
                    prev-icon="fxt-chevron-left"
                    next-icon="fxt-chevron-right">
                </v-pagination>
                <div class="d-flex justify-end">
                    <v-btn
                        class="font-weight-bold secondary-font text-none my-6"
                        color="primary"
                        rounded
                        outlined
                        @click="redirect()"
                    >
                        <div>Søk etter flere</div>
                    </v-btn>
                </div>
            </div>
            <div v-else>
                <v-overlay :value="loading" color="white" absolute style="height: 600px">
                    <v-progress-circular
                        color="var(--v-primary-base)"
                        indeterminate
                        size="64"
                    ></v-progress-circular>
                </v-overlay>
                <no-content v-if="!loading && !salons.length" title="Du har ingen favorittsalonger ennå." icon="fxt-salon" :redirectUrl="portalUrl()" buttonText="Finn din salong" :layout="layout">
                    <div class="description">
                        <p>Du har ingen salonger enda. <br><br>
                        Nye salonger legges til når du bestiller <br> 
                        eller du kan legge til manuelt om du <v-hover v-slot="{ hover }"><span class="text-decoration-underline" :style="hover ? 'cursor: pointer' : ''" @click="appRedirect()">laster ned appen vår</span></v-hover>.</p>
                    </div>
                </no-content>
            </div>
            <common-dialog
                v-if="showDialog" 
                :show="showDialog" 
                :title="`${removedSalon.name} er fjernet!`" 
                icon="fxt-trash"
                buttonTextConfirm="Ok"
                buttonTextCancel="Gå til personvern og samtykker" 
                @closeDialog="consentsRedirect()"
                @confirmAction="showDialog = false"
                :layout="layout"
            >
                <p>For å fjerne dine samtykker knyttet til denne salongen må du i tillegg skru dette av i personvern og samtykker.</p>
            </common-dialog>
        </div>
    </div>
</template>

<script>
import Salon from './components/Salon.vue'
import SalonModel from '../../../../models/Salon'
import { NoContent, TitleAndEdit, CommonDialog } from '../../../Common/CommonComponents'
import ProfileSvc from '../../../../services/profile-svc';
let profileSvc = null;

export default {
    components: { Salon, NoContent, TitleAndEdit, CommonDialog },
    props: {
        layout: {
            required: false,
            default: 'chain',
            type: String
        }
    },
    data: () => ({
        edit: false,
        salons: [],
        loading: false,
        showDialog: false,
        removedSalon: '',
        page: 1,
        perPage: 10,
    }),
    computed: {
        bookingApi() {
            return this.layout == 'portal' ? process.env.VUE_APP_FIXIT_NO_BOOKING_URL : this.$config.VUE_APP_FIXIT_NO_BOOKING_URL ? this.$config.VUE_APP_FIXIT_NO_BOOKING_URL : process.env.VUE_APP_FIXIT_NO_BOOKING_URL
        },
        allSalons() {
            var all = []
            for (const chain of this.salons) {
                all = all.concat(chain.chainSites.map(x => new SalonModel(x)))
            }
            return all
        },
        pages() {
            return this.allSalons.length > 10
                ? Math.ceil(this.allSalons.length / 10)
                : 1;
        },
        visiblePages () {
            return this.allSalons.slice((this.page - 1)* this.perPage, this.page* this.perPage)
        }
    },
    methods: {
        async updateSalon(siteId) {
            this.loading = true;
            this.showDialog = true;
            var result = await profileSvc.UpdateMySalons(this.bookingApi, siteId.toString(), '0')
            if (result ) {
                this.page = 1
                this.salons = this.sortSalons(await profileSvc.GetMySalons(this.bookingApi, 0, '0', false))
            }
            this.loading = false
        },
        consentsRedirect() {
            this.$router.push({path: '/personvern-og-samtykker', query: {chainId: this.removedSalon.chainId}})
        },
        portalUrl() {
            return this.layout == 'portal' ? process.env.VUE_APP_FIXIT_NO_URL : this.$config.PORTAL_URL
        },
        toggleEdit() {
            this.edit = !this.edit
        },
        sortSalons(salons) {
            return salons.sort(function(a, b) {
                return (a.title < b.title) ? -1 : (a.title > b.title) ? 1 : 0;
            });
        },
        redirect() {
            window.open(`${this.portalUrl()}`,'_self')
        },
        appRedirect() {
            this.layout == 'portal' ? window.open(`${this.portalUrl()}/app`,'_self') : this.$router.replace('/app')
        }
    },
    async created() {
		profileSvc = await ProfileSvc(this.$axios);
        this.loading = true;
        this.salons = this.sortSalons(await profileSvc.GetMySalons(this.bookingApi, 0, '0', false))
        this.loading = false;
	},
    beforeDestroy() {
		profileSvc = null
	}
}
</script>
<style scoped>
.description {
    font-weight: 400;
    font-size: 20px;
    line-height: 23px;
}
</style>